<template>
  <div
    :id="id"
    ref="modal"
    class="modal fade"
    tabindex="-1"
    role="dialog"
  >
    <div class="modal-dialog modal-dialog-scrollable modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header">
          <div class="modal-title h3">
            {{ title }}
          </div>
          <button
            type="button"
            class="close"
            data-dismiss="modal"
            aria-hidden="true"
          >
            &times;
          </button>
        </div>
        <div
          v-if="!description"
          class="modal-body"
        >
          <loading-animation class="" />
        </div>
        <div
          v-else
          class="modal-body"
          v-html="description"
        />
      </div>
    </div>
  </div>
</template>

<script>
export default {
    name: 'CategoryModal',
    props: {
        id: {
            type: String,
            required: true
        },
        categoryId: {
            type: Number,
            required: true
        },
        title: {
            type: String,
            required: true
        },
        type: {
            type: String,
            default: 'description1'
        }
    },
    data () {
        return {
            description: null
        }
    },
    mounted () {
        $(this.$refs.modal).on('show.bs.modal', this.loadDescription)
    },
    methods: {
        loadDescription () {
            if (this.description == null) {
                const self = this
                $.ajax({
                    type: 'GET',
                    url: '/rest/io/category/description/' + this.categoryId,
                    data: { [this.type]: 1 },
                    success: (response) => {
                        if (typeof response === 'string') {
                            response = JSON.parse(response)
                        }
                        self.description = response.data[self.type]
                        this.$emit('data:loaded', { description: response.data[self.type] })
                    },
                    error: function (jqXHR, textStatus, errorThrown) {
                        console.error(errorThrown)
                    }
                })
            }
        },
        setDescription (description) {
            this.description = description
        }
    }
}
</script>

<style scoped>

</style>
